import moment from 'moment'

const getDefaultFilter = () => ({
  page: 1,
  pagePosts: 1,
  offsetPosts: 0,
  pagePortals: 1,
  offsetPortals: 0,
  limit: 10,
  withScoring: true,
  pageCalls: 1,
  offsetCalls: 0,
  limitCalls: 10,
  sort: '-date_enregistrement',
  sortCalls: '-dateStarted',
  offset: 0,
  search: '', // Recherche
  searchCalls: '',
  diffusees: false,
  selectionnees: false,
  envoyees: false,
  sanscontacts: null,
  withContacts: null,
  activeOnly: false,
  beforeContacts: moment().subtract(7, 'days'),
  afterContacts: moment(),
  contactManager: true,
  statutAppel: '',
  codeNames: null,
  rapprochement: null,
  annonceParente: null,
  presetPosts: 'withContacts',
  presetPortals: 'withContacts',
  activeName: 'Mailtracking'
})

const getPresetFilters = () => ({
  preset: 'withContacts',
  beforeContacts: moment().subtract(7, 'days'),
  afterContacts: moment()
})

export default {
  namespaced: true,
  state: {
    filter: getDefaultFilter(),
    results: { total: -1, list: [] } // Stockage des derniers résultats pour accélérer le retour arrière
  },
  getters: {
    getContactsDateBefore: (state) => state.filter.beforeContacts,
    getContactsDateAfter: (state) => state.filter.afterContacts
  },
  mutations: {
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setPagePosts (state, pagePosts) {
      state.filter = { ...state.filter, pagePosts }
    },
    setPagePortals (state, pagePortals) {
      state.filter = { ...state.filter, pagePortals }
    },
    setPageCalls (state, pageCalls) {
      state.filter = { ...state.filter, pageCalls }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setSortCalls (state, sortCalls) {
      state.filter = { ...state.filter, sortCalls, pageCalls: 1, pagePosts: 1, pagePortals: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1, pagePosts: 1, pagePortals: 1, offset: 0 }
    },
    setSearchCalls (state, searchCalls) {
      state.filter = { ...state.filter, searchCalls, page: 1, pagePosts: 1, pagePortals: 1, offset: 0 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setOffsetPosts (state, offsetPosts) {
      state.filter = { ...state.filter, offsetPosts, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setOffsetPortals (state, offsetPortals) {
      state.filter = { ...state.filter, offsetPortals, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setOffsetCalls (state, offsetCalls) {
      state.filter = { ...state.filter, offsetCalls, page: 1, pagePosts: 1, pagePortals: 1, pageCalls: 1 }
    },
    setBefore (state, before) {
      state.filter = { ...state.filter, before, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setAfter (state, after) {
      state.filter = { ...state.filter, after, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setBeforeContacts (state, beforeContacts) {
      state.filter = { ...state.filter, beforeContacts, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setAfterContacts (state, afterContacts) {
      state.filter = { ...state.filter, afterContacts, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setStatutAppel (state, statutAppel) {
      state.filter = { ...state.filter, statutAppel, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setDiffusees (state, diffusees) {
      state.filter = { ...state.filter, diffusees, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setSelectionnees (state, selectionnees) {
      state.filter = { ...state.filter, selectionnees, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setEnvoyees (state, envoyees) {
      state.filter = { ...state.filter, envoyees, page: 1, pagePosts: 1, pagePortals: 1 }
    },
    setCodeNames (state, codeNames) {
      state.filter = { ...state.filter, codeNames }
    },
    setRapprochement (state, rapprochement) {
      state.filter = { ...state.filter, rapprochement }
    },
    setAnnonceParente (state, annonceParente) {
      state.filter = { ...state.filter, annonceParente }
    },
    setActiveName (state, activeName) {
      state.filter = { ...state.filter, activeName }
    },
    addFilter (state, filter) {
      // Fusionner les filtres
      state.filter = { ...state.filter, ...filter, page: 1, pagePosts: 1, pagePortals: 1 }
      
      // Supprimer les clés marquées comme undefined (pour nettoyer les filtres désépinglés)
      Object.keys(state.filter).forEach(key => {
        if (state.filter[key] === undefined) {
          delete state.filter[key]
        }
      })
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    }
  }
}
